import { useEffect, useState } from "react";
import MandatorySign from "../../../Components/MandatorySign";
import { Dropdown } from "react-bootstrap";
import ErrorMessage from "../../../Components/ErrorMessage";
import { BiMinus, BiPlus } from "react-icons/bi";

const EMPTY_RULE = {
    interval: "days",
    value: 1,
    hour: 0,
    minute: 0,
};

const InputSchedule = ({
    handleClose,
    handleSelect,
    selectedItem,
    selectedNode
}) => {
    const [customName, setCustomName] = useState("")
    const [rules, setRules] = useState([EMPTY_RULE]);
    const [errorMessage, setErrorMessage] = useState({ message: "", display: false });

    const updateRule = (index, key, value) => {
        setRules((prev) => {
            const updated = [...prev];
            updated[index] = {
                ...updated[index],
                [key]: value,
            };
            return updated;
        });
    };

    const addRule = () => {
        setRules((prev) => [...prev, { ...EMPTY_RULE }]);
    };

    const removeRule = (index) => {
        setRules((prev) => prev.filter((_, i) => i !== index));
    };

    const showTimeFields = (interval) =>
        ["days", "weeks", "months"].includes(interval);

    const handleConfirm = () => {
        if (!customName.trim()) {
            setErrorMessage({ message: "Custom name is required", display: true });
            return;
        }

        handleSelect(selectedItem.value, selectedItem, {
            custom_name: customName,
            rules: rules,
        })
    };

    useEffect(() => {
        if (!selectedNode) return;

        const existingRules =
            selectedNode?.data?.params ||
            selectedNode?.data?.config?.rules ||
            null;

        const existingName = selectedNode?.data?.params?.custom_name;

        if (existingName) {
            setCustomName(existingName)
        }

        if (existingRules && Array.isArray(existingRules)) {
            setRules(existingRules);
        } else {
            setRules([EMPTY_RULE]);
        }
    }, [selectedNode]);

    return (
        <>
            <div className="modal_main_cont">

                <div className="modal_profile_input_cont">
                    <div className="label_input">
                        <label className="input_label">
                            Custom name <MandatorySign message="Custom name is required" />
                        </label>

                        <input
                            type="text"
                            className="register_form_first fade-in"
                            value={customName}
                            placeholder="Scheduled trigger"
                            onChange={(e) => setCustomName(e.target.value)}
                        />
                    </div>

                    {rules.map((rule, index) => (
                        <>
                            <div key={index} className="schedule_rule_box">


                                <div className="label_input">
                                    <label className="input_label">
                                        Trigger Interval <MandatorySign message="Interval is required" />
                                    </label>

                                    <Dropdown drop="down" autoClose="outside">
                                        <Dropdown.Toggle as="div" className="register_form_first fade-in pointer">
                                            {rule.interval.charAt(0).toUpperCase() + rule.interval.slice(1)}
                                        </Dropdown.Toggle>

                                        <Dropdown.Menu className="custom_dropdown_menu">
                                            <div className="scrollable_dropdown_cont">

                                                {["minutes", "hours", "days", "weeks", "months"].map((opt) => (
                                                    <div
                                                        key={opt}
                                                        className={`settings_link ${rule.interval === opt ? "settings_link_selected" : ""}`}
                                                        onClick={() =>
                                                            updateRule(index, "interval", opt)
                                                        }
                                                    >
                                                        {opt.charAt(0).toUpperCase() + opt.slice(1)}
                                                    </div>
                                                ))}

                                            </div>
                                        </Dropdown.Menu>
                                    </Dropdown>
                                </div>

                                <div className="label_input">
                                    <label className="input_label">
                                        Value <MandatorySign message="Value of interval is required" />
                                    </label>

                                    <input
                                        type="number"
                                        min={1}
                                        className="register_form_first fade-in"
                                        value={rule.value}
                                        onChange={(e) =>
                                            updateRule(index, "value", Number(e.target.value))
                                        }
                                    />
                                </div>

                                {showTimeFields(rule.interval) && (
                                    <>
                                        <div className="label_input">
                                            <label className="input_label">Hour</label>
                                            <input
                                                type="number"
                                                min={0}
                                                max={23}
                                                className="register_form_first fade-in"
                                                value={rule.hour}
                                                onChange={(e) =>
                                                    updateRule(index, "hour", Number(e.target.value))
                                                }
                                            />
                                        </div>

                                        <div className="label_input">
                                            <label className="input_label">Minute</label>
                                            <input
                                                type="number"
                                                min={0}
                                                max={59}
                                                className="register_form_first fade-in"
                                                value={rule.minute}
                                                onChange={(e) =>
                                                    updateRule(index, "minute", Number(e.target.value))
                                                }
                                            />
                                        </div>
                                    </>
                                )}


                                {rules.length > 1 && (
                                    <div className="schedule_rule_box_btn_cont">
                                        <button
                                            className="schedule_rule_box_btn schedule_rule_box_btn_del"
                                            onClick={() => removeRule(index)}
                                        >
                                            <BiMinus />
                                        </button>
                                    </div>
                                )}

                            </div>
                            <button
                                className="schedule_rule_box_btn"
                                onClick={addRule}
                            >
                                <BiPlus /> Add rule
                            </button>
                        </>
                    ))}
                </div>
            </div>

            <div className="modal_footer">
                <div className="modal_footer_err_cont">
                    <ErrorMessage err={errorMessage} />
                </div>

                <div className="modal_footer_btn_cont">
                    <button
                        className="modale_save_btn"
                        onClick={handleConfirm}
                    >
                        Confirm
                    </button>
                    <button
                        className="modale_close_btn"
                        onClick={handleClose}
                    >
                        Close
                    </button>
                </div>
            </div>

        </>

    );
};

export default InputSchedule;